




















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  IDatosSertecDropdown,
  DatosSertecDropdown,
} from '@/interfaces/DatosSertecDropdowns';
import { Validator } from 'vee-validate';
import { IDatosSertec, DatosSertecClass } from '@/interfaces/DatosSertecClass';
import config from '@/config/index';
import GridSertec from './GridSertec.vue';
import { asociacionEventBus } from '@/setup';
import { fetchDashboard } from '@/pantallas/Dashboard/fetchDashboard';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    GridSertec,
    'app-confirmacion': Confirmation,
  },
})
export default class DatosSertec extends Vue {
  dateStartDialog: Boolean = false;
  showForm: Boolean = false;
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacionClose: boolean = false;
  dateSelected: any = null;
  fechaOrigenSelected: string = '';
  fechaAperturaelected: string = '';
  fechaCoordinacionSelected: string = '';
  fechaSolucionSelected: string = '';
  DatosSertecClass = new DatosSertecClass();
  DatosSertecDropdown = new DatosSertecDropdown();

  datePikerSelected: number = null;
  acciones: any = ['Guardar', 'guardar cambios'];
  accionSeleccionada: number = 0;
  clienteId: number = null;
  $snotify: any;
  minDate: any = '';
  datosSertec: IDatosSertec = this.DatosSertecClass.datos;
  datosSertecDropdown: IDatosSertecDropdown = this.DatosSertecDropdown.datos;

  initialize() {
    this.clienteId = parseInt(localStorage.getItem('clienteDefecto'));

    this.showForm = true;
    this.dictionaryFormErrors = {
      es: {
        custom: {
          caso: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
          },
          transportista: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
          },
          planta: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
          },
          patente: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
          },
          producto: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
          },
          diasSolucion: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
            numeric:
              '* El campo Apellido Materno solo debe contener letras y/o espacios.',
          },
          tipoSoporte: {
            alpha_num: () =>
              '* El Número de serie solo debe contener números y/o letras.',
            required: 'El soporte de ola.',
            max: config.errorMensajes.maxLength,
          },
          estado: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
            alpha_num:
              '* El Número de serie solo debe contener números y/o letras.',
          },
          motivo: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
          },
          comentario: {
            required: config.errorMensajes.textoRequerido,
            max: config.errorMensajes.maxLength,
          },
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  confirmCallbackConfirm(val: boolean) {
    if (val) {
      this.DatosSertecClass = new DatosSertecClass();
      this.datosSertec = this.DatosSertecClass.datos;
      this.$validator.reset();
      this.accionSeleccionada = 0;
    }
    this.dialogConfirmacionClose = false;
  }
  mounted() {
    if (parseInt(localStorage.getItem('clienteDefecto')) != 3833) {
      this.showForm = false;
      return;
    }
    this.showForm = true;
    asociacionEventBus.$on('editar', (data: IDatosSertec) => {
      this.DatosSertecClass = new DatosSertecClass();
      this.datosSertec = this.DatosSertecClass.datos;
      this.datosSertec = data;
      this.accionSeleccionada = 1;
      // this.datosSertec.fecha_origen_falla = this.formatDate(
      //   this.datosSertec.fecha_origen_falla
      // );
      // this.datosSertec.fecha_apertura_ticket = this.formatDate(
      //   this.datosSertec.fecha_apertura_ticket
      // );
      // this.datosSertec.fecha_coordinacion_trabajos = this.formatDate(
      //   this.datosSertec.fecha_coordinacion_trabajos
      // );
      // this.datosSertec.fecha_solucion_definitiva = this.formatDate(
      //   this.datosSertec.fecha_solucion_definitiva
      // );
    });
    this.scrollToTop();
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  getDataPiker(aux: number) {
    this.datePikerSelected = aux;
    this.dateStartDialog = true;
  }
  formatDate = (current_datetime: any) => {
    const d = new Date(0);
    let formatted_date =
      current_datetime +
      ' ' +
      d.getHours() +
      ':' +
      d.getMinutes() +
      ':' +
      d.getSeconds();
    return formatted_date;
  };
  dateSeleccionFin() {
    switch (this.datePikerSelected) {
      case 0:
        this.fechaOrigenSelected = this.formatDate(this.dateSelected);
        this.datosSertec.fecha_origen_falla = this.formatDate(
          this.dateSelected
        );
        break;
      case 1:
        this.fechaAperturaelected = this.formatDate(this.dateSelected);
        this.datosSertec.fecha_apertura_ticket = this.formatDate(
          this.dateSelected
        );
        break;
      case 2:
        this.fechaCoordinacionSelected = this.formatDate(this.dateSelected);
        this.datosSertec.fecha_coordinacion_trabajos = this.formatDate(
          this.dateSelected
        );
        break;
      case 3:
        this.fechaSolucionSelected = this.formatDate(this.dateSelected);
        this.datosSertec.fecha_solucion_definitiva = this.formatDate(
          this.dateSelected
        );
        break;
    }
    this.dateSelected = '';
    this.dateStartDialog = false;
  }
  handleSubmit() {
    this.$validator.validateAll().then(async resultado => {
      if (resultado) {
        const refGrilla = this.$refs.grilla as any;
        this.datosSertec.tipo_caso = this.datosSertec.tipo_caso.toUpperCase();
        this.datosSertec.estado = this.datosSertec.estado.toUpperCase();
        this.datosSertec.nro_caso = this.datosSertec.nro_caso.toUpperCase();
        this.datosSertec.planta = this.datosSertec.planta.toUpperCase();
        this.datosSertec.producto = this.datosSertec.producto.toUpperCase();
        this.datosSertec.patente = this.datosSertec.patente.toUpperCase();
        this.datosSertec.transportista = this.datosSertec.transportista.toUpperCase();
        this.datosSertec.estado = this.datosSertec.estado.toUpperCase();
        this.datosSertec.nro_caso = this.datosSertec.nro_caso.toUpperCase();
        this.datosSertec.motivo_rechazo = this.datosSertec.motivo_rechazo.toUpperCase();
        this.datosSertec.comentario = this.datosSertec.comentario
          .split('\n')
          .join(' ');
        let url = 'mantenedor_sertec/agregar_editar';
        this.datosSertec = {
          ...this.datosSertec,
          id_cliente: this.clienteId,
          segmentacion: 'esmax',
        };
        let result = await fetchDashboard(this.datosSertec, url);
        result.data.CODIGO_RESPUESTA == 1
          ? (this.$snotify.success(result.data.MENSAJE_RESPUESTA),
            (this.DatosSertecClass = new DatosSertecClass()),
            (this.datosSertec = this.DatosSertecClass.datos),
            this.$validator.reset(),
            refGrilla.getGrilla(),
            (this.accionSeleccionada = 0))
          : this.$snotify.error(result.data.MENSAJE_RESPUESTA);
      }
    });
  }
  cancelar() {
    this.dialogConfirmacionClose = true;
  }
  async fetchDashboard(body: any, path: any) {
    let response = await fetchDashboard(body, path);
    return response;
  }
  quitarAcentos(cadena: string) {
    const acentos: any = {
      á: 'a',
      é: 'e',
      í: 'i',
      ó: 'o',
      ú: 'u',
      Á: 'A',
      É: 'E',
      Í: 'I',
      Ó: 'O',
      Ú: 'U',
    };
    return cadena
      .split('')
      .map(letra => acentos[letra] || letra)
      .join('')
      .toString();
  }
}
